<template>
    <!-- 核验中心 -->
    <section class="checkCenter">
        <!-- 顶部背景图 -->
        <div class="checkCenter-top">
            <p>核验中心</p>
            <span>支持针对已接入【北宸可信数据服务中心】的数据进行真实性核验<br />已获得上海市高院授权，支持相关司法证据核验。</span>
        </div>
        <!-- 核验中心 -->
        <div class="layoutContent checkCon">
            <h1>核验中心</h1>
            <div class="masterImg" style="margin-bottom: 45px;">
                <img src="@/assets/img/home/ks1.png" @click="goCheck1" />
            </div>
            <div class="masterImg masterImg1" style="margin-bottom: 45px;">
                <img src="@/assets/img/home/ks2.png" @click="goCheck2" />
            </div>
            <div class="masterImg masterImg2">
                <img src="@/assets/img/home/ks3.png" @click="goCheck3" />
            </div>
        </div>
    </section>
</template>

<script>

export default {
    data() {
        return {
        }
    },
    methods: {
        // 外链校验
        goCheck1() {
            window.location.href = 'https://sheca.yrd-tdh.com:8000/sign-depository-platform'
        },
        // 内部核验
        goCheck2() {
            this.$router.push('/check')
        },
        goCheck3() {
            this.$router.push('/check2')
        },
    }
}
</script>

<style lang="less">
@import "../../style/base.less";
</style>

<style lang="less" scoped>
.checkCenter-top {
    height: 320px;
    background: url(../../assets/center/bg.jpg) no-repeat 0 center;
    background-size: 100% 100%;
    padding: 80px 10px 20px 270px;

    p {
        font-size: 34px;
        color: #fff;
        margin-bottom: 10px;
    }

    span {
        font-size: 16px;
        color: #fff;
    }
}

.checkCon {
    padding: 40px 0 70px;
    background: url(../../assets/center/bg-con.jpg) no-repeat 0 center;
    background-size: 100% 100%;

    h1 {
        font-size: 24px;
        letter-spacing: 8px;
        margin-bottom: 30px;
        text-align: center;
    }

}

.masterImg {
    width: 540px;
    height: 320px;
    background: url("../../assets/img/home/m-bg-left.png") no-repeat 0 center;
    background-size: 100% 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    box-shadow: 0 0 20px 5px rgba(0, 0, 0, 0.1);

    &>img {
        width: 210px;
        margin: 0 0 60px 40px;
        cursor: pointer;
        transform: scale(1);
        transition: transform 0.3s ease;
    }
}

.masterImg1 {
    background: url("../../assets/img/home/m-bg-right.png") no-repeat 0 center;
    background-size: 100% 100%;
}

.masterImg2 {
    background: url("../../assets/img/home/m-tre.png") no-repeat 0 center;
    background-size: 100% 100%;
}

.masterImg img:hover {
    transform: scale(1.03);
}
</style>


// WEBPACK FOOTER //
// src/views/checkCenter/index.vue